import { Box, Typography, Button } from "@mui/material";
import React, { useState } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import { Gnft113names, Nft113names } from "../assets/scripts";
import DisplayData from "./sub-Components/DisplayData";

const ApiDefines = () => {
    const [dataReceived, setDataReceived] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [selectedOptions, setSelectedOptions] = useState([]);

    const handleSelectChange = async (selectedOptions) => {
        // console.log(selectedOptions);
        setLoading(true);
        try {
            const response = await fetch('https://apivsfintech.invtechnologies.in/getselectedheatmapdata', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ "data": selectedOptions }),
            });
            if (response.ok) {
                const data = await response.json();
                const arr = data.data.reverse();
                // console.log(arr);
                setDataReceived(arr);
            }
            setLoading(false);
        } catch (err) {
            console.error('Error getting data:', err);
            setLoading(false);
        }
    };

    const handlePcntRanks = () => {
        handleSelectChange(Nft113names);
    }
    const handlePrices = () => {
        handleSelectChange(Gnft113names);
    }
    return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Box sx={{ width: "90%", boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", padding: "10px 40px" }}>
                <Box sx={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                <Typography>Api to get All indices PCNT Ranks</Typography>
                <Button variant="contained" disabled={loading} onClick={() => handlePcntRanks()} >All pcnt data</Button>
                </Box>
                <Box p={1} />
                <Box sx={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                <Typography>Api to get All indices Prices</Typography>
                <Button variant="contained" disabled={loading} onClick={() => handlePrices()} >All Prices data</Button>
                </Box>
            </Box>
            <Box p={1} />
            <Box sx={{ width: "90%", boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", padding: "10px 40px", }}>
                {
                    loading ? <Box sx={{ width: "100%", height: "30rem", display: "flex", justifyContent: "center", alignItems: "center" }}><CircularProgress /> </Box> 
                    : 
                    <Box 
                    sx={{width:"66vw", overflow:"hidden"}}
                    >
                        <DisplayData dataReceived={dataReceived} />
                    </Box>
                }
            </Box>
        </Box>
    );
};

export default ApiDefines;